// extracted by mini-css-extract-plugin
module.exports = {"col1":"double-column-col1__syrZi","col2":"double-column-col2__2IAim","col2_overflow":"double-column-col2_overflow__1kdEh"};